import { HStack, Text, Icon, VStack } from '@chakra-ui/react';
import { IoMdPin } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';

import LocationCard from './LocationCard';

export type LocationWithDistanceCardProps = {
  name: string;
  location: string;
  time: string;
  distance: string;
};

// 歸還餐盒地點全部列表
export default function LocationWithDistanceCard({
  name,
  location,
  time,
  distance,
}: LocationWithDistanceCardProps) {
  const navigate = useNavigate();
  const handleOnClick = () => {
    navigate(`/mealBoxRecycling/locationInfo/111`);
  };

  return (
    <VStack align="stretch">
      <HStack bg="gray.100" p={1} spacing={1} borderRadius="5px">
        <Icon color="gray.700" as={IoMdPin} boxSize="1rem" />
        <Text fontSize="xs" color="gray.700">
          {distance}
        </Text>
      </HStack>

      <LocationCard name={name} location={location} time={time} image="" onClick={handleOnClick} />
    </VStack>
  );
}
